import { render, staticRenderFns } from "./list-servizi.vue?vue&type=template&id=00249f2d&"
import script from "./list-servizi.vue?vue&type=script&lang=js&"
export * from "./list-servizi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports